import {override } from 'flarum/extend';
import IndexPage from 'flarum/components/IndexPage';

import TagHero from '../../components/TagHero';

export default function() {

  // If currently viewing a tag, insert a tag hero at the top of the view.
  override(IndexPage.prototype, 'hero', function(original) {
    const tag = this.getCurrentTag();
    if (tag) {
      return TagHero.component({model: tag});
    }

    return original();
  });
}
